import { useQuery } from '@apollo/client';

import { MY_RUNNING_BATCH_JOB_QUERY } from '@/gql/queries/batch-action.gql';

/**
 * One-shot (no polling) fetch of the caller's most-recent non-terminal batch
 * job FOR A GIVEN WORKFLOW, used by that workflow's overview to re-attach its
 * progress drawer after a page reload. Scoped to `workflowId` so a job running
 * on another workflow never opens a drawer here. `network-only` so a stale
 * cached pointer never re-opens a drawer for a job that already finished. Pass
 * `{ skip: true }` to suppress the query (e.g. when a job is already open from a
 * fresh submit).
 */
export function useMyRunningBatchJob(
  workflowId: string,
  options?: { skip?: boolean }
) {
  const { data, loading } = useQuery(MY_RUNNING_BATCH_JOB_QUERY, {
    variables: { workflowId },
    skip: options?.skip,
    fetchPolicy: 'network-only'
  });
  return { runningJob: data?.myRunningBatchJob ?? null, loading };
}
